import {
  deleteBillInfoAction,
  disableIsDirtyAction,
  newRequestPatchStateAction,
  onChangeAcceptTermAndConditionsAction,
  paymentSelectedIsDirtyAction,
  planSelectedIsDirtyAction,
  dispatchSelectedIsDirtyAction,
  resetReCaptchaTokenAction,
  setGeneralData,
  setGeneralDataErrors,
  setPlanDataAction,
  setDispatchDataAction,
  setPlanDataErrorsAction,
  setDispatchDataErrorsAction,
  updateBillInfoAction,
  updateBrandAndBillIssuerAction,
  updateBillIssuerManagersAction,
  updateDispatchRegionDataAction,
  updateGeneralDataIsDirtyAction,
  updatePaymentTypeAction,
  updatePlantTypeAction,
  setPatchGeneralData,
} from "./new-request.reducer";

import {
  loadBrandAndBillIssuerAction,
  loadDispatchBillIssuerAction,
  getManagerByBillIssuerAction,
  onExternalErrorAction,
  onNewRequestAction,
  satisfactoryPaymentAction,
  syncCurrentReport,
  updateGeneralDataAction,
  updateDispatchDataAction,
  onBackDispatchStepAction,
} from "./new-request.effects";

import { newRequestState } from "./state";

export const models = {
  state: newRequestState,
  reducers: {
    reset: (state) => newRequestState,
    updateBillInfoAction,
    deleteBillInfoAction,
    updatePaymentTypeAction,
    updateGeneralDataIsDirtyAction,
    setGeneralData,
    setPatchGeneralData,
    setGeneralDataErrors,
    disableIsDirtyAction,
    paymentSelectedIsDirtyAction,
    planSelectedIsDirtyAction,
    dispatchSelectedIsDirtyAction,
    updatePlantTypeAction,
    setPlanDataAction,
    setDispatchDataAction,
    setPlanDataErrorsAction,
    setDispatchDataErrorsAction,
    onChangeAcceptTermAndConditionsAction,
    resetReCaptchaTokenAction,
    newRequestPatchStateAction,
    updateBrandAndBillIssuerAction,
    updateDispatchRegionDataAction,
    updateBillIssuerManagersAction,
  },
  effects: (dispatch) => ({
    updateGeneralDataAction: async function (data) {
      return await updateGeneralDataAction.call(this, data, dispatch);
    },
    updateDispatchDataAction: async function (data, state) {
      return await updateDispatchDataAction.call(
        this,
        data,
        state.newRequest,
        dispatch
      );
    },
    onBackDispatchStepAction: async function (data) {
      return await onBackDispatchStepAction.call(this, data, dispatch);
    },
    onNewRequestAction: async function (_, state) {
      return await onNewRequestAction.call(this, state, dispatch);
    },
    handlerExternalError: async function (payload, state) {
      return await onExternalErrorAction.call(this, payload, state, dispatch);
    },
    satisfactoryPayment: function () {
      return satisfactoryPaymentAction.call(this, dispatch);
    },
    syncCurrentReportAction: function (reportId) {
      return syncCurrentReport.call(this, reportId, dispatch);
    },
    loadBrandAndBillIssuerAction: async function () {
      return await loadBrandAndBillIssuerAction.call(this, dispatch);
    },
    loadDispatchBillIssuerAction: async function (billIssuerName) {
      return await loadDispatchBillIssuerAction.call(
        this,
        billIssuerName,
        dispatch
      );
    },
    getManagerByBillIssuerAction: async function (billIssuerName) {
      return await getManagerByBillIssuerAction.call(
        this,
        billIssuerName,
        dispatch
      );
    },
  }),
  selectors: (slice) => ({
    ui() {
      return slice((newReportState) => newReportState.ui);
    },
    data() {
      return slice((newReportState) => newReportState.data);
    },
  }),
};
